<template>
  <div class="sidebarHelp">
    <div class="sidebarHelp__fixedContainer">
      <CSButton
        v-if="collapsable"
        id="sidebar-help-collapse-btn"
        flat
        icon
        data-test="collapse-btn"
        @click="handleCollapseBtnClick(!value)"
        :class="{
          sidebarHelp__collapseBtn: true,
          'sidebarHelp__collapseBtn--info': value,
        }"
      >
        <CSSVGIcon
          data-test="collapse-icon"
          :iconName="value ? 'cs_chevron-left' : 'cs_chevron-right'"
          class="sidebarHelp__collapseIcon"
        />
        <CSSVGIcon
          v-if="value"
          data-test="info-icon"
          iconName="cs_help-circle"
          class="sidebarHelp__collapseIcon"
        />
      </CSButton>

      <div v-if="!value" class="sidebarHelp__content" data-test="content">
        <div data-test="title" class="sidebarHelp__title">
          {{ translate('ABOUT_BOOKINGS') }}
        </div>

        <div data-test="help-items">
          <SidebarHelpItem
            class="sidebarHelp__helpItem"
            icon="calendar-clock"
            :title="translate('HOW_BOOKINGS_WORK')"
            :description="translate('HOW_BOOKINGS_WORK_DESCRIPTION')"
          />

          <SidebarHelpItem
            class="sidebarHelp__helpItem"
            icon="accounting-coins-bill"
            :title="translate('ESTIMATED_TOTAL_COST')"
            :description="translate('ESTIMATED_TOTAL_COST_DESCRIPTION')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CSButton from '@/components/atoms/button/CSButton.vue'
import CSSVGIcon from '@/components/atoms/icons/CSSVGIcon.vue'

import SidebarHelpItem from './sidebarHelpItem.vue'

export default {
  name: 'SidebarHelp',

  components: {
    SidebarHelpItem,
    CSSVGIcon,
    CSButton,
  },

  props: {
    collapsable: {
      type: Boolean,
    },

    value: {
      type: Boolean,
    },
  },

  methods: {
    handleCollapseBtnClick(newValue) {
      this.$gtm.trackEvent({
        category: 'customer app help sidebar',
        action: newValue ? 'user collapsed sidebar' : 'user expanded sidebar',
        interactive: true,
      })

      this.$emit('input', newValue)
    },
  },
}
</script>
